export default __webpack_public_path__ + "static/media/13.14845819.jpg";